export default __webpack_public_path__ + "static/media/room_bg_1.0c90118c.jpg";